export const TYPES: { [key: string]: symbol } = new Proxy(
  {},
  {
    get: (_, key) => {
      return String(key);
    },
  },
);
